import {IPresentation} from '../../incase-domain/presentation';
import {ISlidePreview} from '../../incase-domain/proptypes/slidePreview';
import {ISlide} from '../../incase-domain/slide';
import {
    IAddEmittedSlideAction,
    IBringElementToFrontAction,
    ICopyEmittedSlideAction,
    ICreateSlideCopyAction,
    IDeleteSlideAction,
    IImportEmittedSlideAction,
    IRemoveEmittedSlideAction,
    ISendElementToBackAction,
    ISetContextSelectedElementIndexAction,
    ISetEmittedSlideAction,
    ISetHighlightedElementIndexAction,
    ISetIsSlideModifiedAction,
    ISetIsSlideModifiedDuringUpdateAction,
    ISetSelectedElementId,
    ISwapEmittedSlideAction,
    IUpdateEmittedSlideAction,
    IUpdateEmittedSlidePreviewAction,
    IUpdateScaleAction,
    IUpdateSelectedSlideAction,
    IUpdateSlideWithoutElementsAction,
} from './types/slide.types';

export const UPDATE_SELECTED_SLIDE = 'UPDATE_SELECTED_SLIDE';
export const CREATE_SLIDE_COPY = 'CREATE_SLIDE_COPY';
export const DELETE_SLIDE = 'DELETE_SLIDE';
export const UPDATE_SLIDE_WITHOUT_ELEMENTS_ACTION = 'UPDATE_SLIDE_HIDDEN_ACTION';
export const UPDATE_SCALE = 'UPDATE_SCALE';
export const SET_IS_SLIDE_MODIFIED_ACTION = 'SET_SLIDE_IS_MODIFIED_ACTION';
export const SET_IS_SLIDE_MODIFIED_DURING_UPDATE_ACTION = 'SET_IS_SLIDE_MODIFIED_DURING_UPDATE_ACTION';
export const UPDATE_EMITTED_SLIDE_ACTION = 'UPDATE_EMITTED_SLIDE_ACTION';
export const ADD_EMITTED_SLIDE_ACTION = 'ADD_EMITTED_SLIDE_ACTION';
export const REMOVE_EMITTED_SLIDE_ACTION = 'REMOVE_EMITTED_SLIDE_ACTION';
export const COPY_EMITTED_SLIDE_ACTION = 'COPY_EMITTED_SLIDE_ACTION';
export const UPDATE_EMITTED_SLIDE_PREVIEW_ACTION = 'UPDATE_EMITTED_SLIDE_PREVIEW_ACTION';
export const SWAP_EMITTED_SLIDE_ACTION = 'SWAP_EMITTED_SLIDE_ACTION';
export const IMPORT_EMITTED_SLIDE_ACTION = 'IMPORT_EMITTED_SLIDE_ACTION';
export const SET_EMITTED_SLIDE_ACTION = 'SET_EMITTED_SLIDE_ACTION';
export const BRING_ELEMENT_TO_FRONT = 'BRING_SLIDE_TO_FRONT';
export const SEND_ELEMENT_TO_BACK = 'SEND_SLIDE_TO_BACK';
export const SET_HIGHLIGHTED_ELEMENT_INDEX = 'SET_HIGHLIGHTED_ELEMENT_INDEX';
export const SET_SELECTED_ELEMENT_ID = 'SET_SELECTED_ELEMENT_ID';
export const SET_CONTEXT_SELECTED_ELEMENT_INDEX = 'SET_CONTEXT_SELECTED_ELEMENT_INDEX';

export const setSelectedElementId = (elementId?: string): ISetSelectedElementId => ({
    type: SET_SELECTED_ELEMENT_ID,
    payload: elementId,
});

export const updateSelectedSlideAction = (slide: ISlide, slideIndex: number, isModified: boolean): IUpdateSelectedSlideAction => ({
    type: UPDATE_SELECTED_SLIDE,
    slide,
    slideIndex,
    isModified,
});

export const createSlideCopyAction = (slide: ISlide, numCopies: number): ICreateSlideCopyAction => ({
    type: CREATE_SLIDE_COPY,
    slide,
    numCopies,
});

export const deleteSlideAction = (slide: ISlide): IDeleteSlideAction => ({
    type: DELETE_SLIDE,
    slide,
});

export const updateSlideWithoutElementsAction = (slide: ISlide): IUpdateSlideWithoutElementsAction => ({
    type: UPDATE_SLIDE_WITHOUT_ELEMENTS_ACTION,
    slide,
});

export const updateScale = (scale: number): IUpdateScaleAction => ({
    type: UPDATE_SCALE,
    scale,
});

export const setIsSlideModifiedAction = (isModified: boolean): ISetIsSlideModifiedAction => ({
    type: SET_IS_SLIDE_MODIFIED_ACTION,
    isModified,
});

export const setIsSlideModifiedDuringUpdateAction = (isModifiedDuringUpdate: boolean): ISetIsSlideModifiedDuringUpdateAction => ({
    type: SET_IS_SLIDE_MODIFIED_DURING_UPDATE_ACTION,
    isModifiedDuringUpdate,
});

export const setEmittedSlideAction = (emittedSlide: ISlide): ISetEmittedSlideAction => ({
    type: SET_EMITTED_SLIDE_ACTION,
    emittedSlide,
});

export const updateEmittedSlideAction = (slide: ISlide): IUpdateEmittedSlideAction => ({
    type: UPDATE_EMITTED_SLIDE_ACTION,
    slide,
});

export const addEmittedSlideAction = (slides: ISlide[], slideIndexList: string[]): IAddEmittedSlideAction => ({
    type: ADD_EMITTED_SLIDE_ACTION,
    slides,
    slideIndexList,
});

export const removeEmittedSlideAction = (slideId: string): IRemoveEmittedSlideAction => ({
    type: REMOVE_EMITTED_SLIDE_ACTION,
    slideId,
});

export const copyEmittedSlideAction = (slideId: string, slide: ISlide): ICopyEmittedSlideAction => ({
    type: COPY_EMITTED_SLIDE_ACTION,
    slideId,
    slide,
});

export const updateEmittedSlidePreviewAction = (slidePreview: ISlidePreview): IUpdateEmittedSlidePreviewAction => ({
    type: UPDATE_EMITTED_SLIDE_PREVIEW_ACTION,
    slidePreview,
});

export const swapEmittedSlideAction = (slideIndexList: string[]): ISwapEmittedSlideAction => ({
    type: SWAP_EMITTED_SLIDE_ACTION,
    slideIndexList,
});

export const importEmittedSlideAction = (slides: ISlide[], presentation: IPresentation): IImportEmittedSlideAction => ({
    type: IMPORT_EMITTED_SLIDE_ACTION,
    slides,
    presentation,
});

export const bringElementToFrontAction = (elementIndex: number): IBringElementToFrontAction => ({
    type: BRING_ELEMENT_TO_FRONT,
    elementIndex,
});

export const sendElementToBackAction = (elementIndex: number): ISendElementToBackAction => ({
    type: SEND_ELEMENT_TO_BACK,
    elementIndex,
});

export const setHighlightedElementIndex = (highlightedElementIndex: number): ISetHighlightedElementIndexAction => ({
    type: SET_HIGHLIGHTED_ELEMENT_INDEX,
    highlightedElementIndex,
});

export const setContextSelectedElementIndex = (contextSelectedElementIndex: number | null): ISetContextSelectedElementIndexAction => ({
    type: SET_CONTEXT_SELECTED_ELEMENT_INDEX,
    contextSelectedElementIndex,
});
